var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBlueLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34866 11.3446H6.87897V8.47183H6.34866C6.05578 8.47183 5.81836 8.29377 5.81836 8.0741V7.12411C5.81836 6.90445 6.05578 6.72638 6.34866 6.72638H9.31836C9.61125 6.72638 9.84866 6.90445 9.84866 7.12411V11.3446H10.379C10.6719 11.3446 10.9093 11.5226 10.9093 11.7423V12.6923C10.9093 12.912 10.6719 13.09 10.379 13.09H6.34866C6.05578 13.09 5.81836 12.912 5.81836 12.6923V11.7423C5.81836 11.5226 6.05578 11.3446 6.34866 11.3446ZM8.36381 2.9082C7.30944 2.9082 6.45472 3.54924 6.45472 4.34002C6.45472 5.1308 7.30944 5.77184 8.36381 5.77184C9.41819 5.77184 10.2729 5.1308 10.2729 4.34002C10.2729 3.54924 9.41816 2.9082 8.36381 2.9082Z",
    fill: "#D3F2F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlueLight);
export default __webpack_public_path__ + "static/media/info-blue-light.efe5fb30e099ba78e1b63c00228f7c78.svg";
export { ForwardRef as ReactComponent };